import { Component, OnInit, Inject, Injectable } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { CategoryService } from "../../services/category_layers/category.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-modal-category",
  templateUrl: "./modal-category.component.html",
  styleUrls: ["./modal-category.component.css"]
})
export class ModalCategoryComponent implements OnInit {
  name: string;
  id: any;
  date: any;
  user: any;
  hash: any;
  action_type: any;

  public categoryForm: FormGroup;

  constructor(
    protected categoryService: CategoryService,
    private dialogRef: MatDialogRef<ModalCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.action_type = "create";
    if (typeof data.data !== "undefined") {
      this.id = data.data.categoria_capa_id;
      this.name = data.data.categoria_capa_nombre;
      this.hash = data.data.gx_md5_hash;
      this.action_type = "edit";
    }
  }

  ngOnInit() {
  
  }

  public closeMe() {
    this.dialogRef.close();
  }

  public createCategory() {
    var categoryDetails = {
      categoria_capa_nombre: this.name,
      categoria_capa_fecha_creacion: this.date
    };

    this.categoryService
      .createCategory(categoryDetails)
      .subscribe((data: {}) => {
        this.dialogRef.close({ data: data });
      });
  }

  public editCategory() {
    var categoryDetails = {
      categoria_capa_id: this.id,
      categoria_capa_nombre: this.name,
      categoria_capa_fecha_creacion: this.date,
      gx_md5_hash: this.hash
    };

    this.categoryService
      .updateCategory(this.id, categoryDetails)
      .subscribe((data: {}) => {
        this.dialogRef.close({ data: data });
      });
  }

  deleteCategory(id) {
    this.categoryService.deleteCategory(this.id).subscribe((data: {}) => {
      this.dialogRef.close({ data: data, type: this.action_type });
    });
  }

  public close() {
    this.dialogRef.close();
  }
}
